export default {
    data() {
        return {
            current: -1
        }
    },
    watch: {
        current(val, oldVal) {
            const index = val
            this.$router.push({ path: "mhome", query: { index } })
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/tabberOptions.js